/**
 * Legacy Sendbird v3 chat actions.
 *
 * These are v3-only actions that do NOT exist in the modern (v4) chat.
 * Shared actions (setActiveChannelAction, setOpenAction, etc.) remain in domain/chat/chatActions.js.
 */
import { asyncAction, syncAction } from 'lib/action';

export const chatConnectAction = asyncAction('CHAT/CONNECT');
export const chatGetThreadsAction = asyncAction('CHAT/GET_THREAD');
export const chatGetWorkerThreadsAction = asyncAction('CHAT/GET_WORKER_THREAD');
export const chatDisConnectAction = asyncAction('CHAT/DIS_CONNECT');

export const createChannelAction = asyncAction('CHAT/CREATE_CHANNEL');
export const sendMessageAction = asyncAction('CHAT/SEND_MESSAGE');
export const receiveMessageAction = asyncAction('CHAT/RECEIVE_MESSAGE');
export const documentAddThreadAction = syncAction('CHAT/DOCUMENT_THREAD');

export const setCounterAction = syncAction('CHAT/SET_COUNTER');
export const getPreviousMessageAction = asyncAction('CHAT/GET_PREVIUS_MESSAGE', (name) => ({ payload: { name } }));
export const setMessageHandlerIdAction = syncAction('CHAT/SET_MESSAGE_HANDLER_ID');

export const getMessagesAction = asyncAction('CHAT/GET_MESSAGES');
export const markChannelAsReadAction = syncAction('CHAT/MARK_CHANNEL_AS_READ');
export const setChatConnectionStatusAction = syncAction('CHAT/SET_CHAT_CONNECTION_STATUS');
export const terminateChannelsAction = asyncAction('CHAT/TERMINATE_CHANNELS');

export const setOnPageAction = syncAction('CHAT/SET_ON_PAGE');
export const setAllowedChatWorkerAction = syncAction('CHAT/SET_ALLOWED_CHAT_WORKER');
